export default __webpack_public_path__ + "static/media/sampleEmployeeImageLocationMonitoring.578ed31e.svg";